import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import React from 'react'

import WhatsappListDialog from './whatsapp-list-dialog'

type Props = {
  content: any
  listOpen: boolean
  onOpen: () => void
  onClose: () => void
}

const WhatsappList: React.FC<Props> = ({ content, listOpen, onOpen, onClose }) => (
  <>
    <Typography style={{ whiteSpace: 'pre-line' }}>{content.message}</Typography>
    <Button variant="contained" onClick={onOpen}>
      {content.button}
    </Button>
    <WhatsappListDialog closeAfterTransition list={content} open={listOpen} onClick={onClose} onClose={onClose} />
  </>
)

export default WhatsappList
